import { Action, createReducer, on } from '@ngrx/store';
import { EOrderSource } from 'src/app/models/data/sales-order.model';
import * as OrderUIActions from '../actions/order-ui.actions'


export const orderUiFeatureKey = 'orderUi';

export interface State {
  uiselectedOrderStatus:string[],
  uiselectedOrderCreator:string[],
  uiselectedOrderTimeRange:number[],
  uiselectedOrderSource:EOrderSource[],
  uiselectedOrderCustomerName:string[],
  uiselectedOrderCustomerCode:string[],
  uiselectedOrderProcessor:string[],
  uiselectedOrderId:number,
  uiSearchPurchaserName: string,
  uiOrderDetailLoading :{
    loadingSwitch:boolean
    loadingTip?:string
  },
  uiOrderListTableLoading:boolean
  uiPreviewOrderUploadLoading:boolean
  uiPreferenceSOCraeteLoading:boolean
}

export const initialState: State = {
  uiselectedOrderStatus:null,
  uiselectedOrderCreator:null,
  uiselectedOrderTimeRange: null,
  uiselectedOrderSource:null,
  uiselectedOrderCustomerName:null,
  uiselectedOrderCustomerCode:null,
  uiselectedOrderProcessor:null,
  uiselectedOrderId:null,
  uiOrderDetailLoading:{loadingSwitch:false},
  uiSearchPurchaserName:'',
  uiOrderListTableLoading:false,
  uiPreviewOrderUploadLoading: false,
  uiPreferenceSOCraeteLoading:false,
};


export const reducer = createReducer(
  initialState,


  on(OrderUIActions.setUISelectedOrderStatus,(state,action) => {
    return{
      ...state,
      uiselectedOrderStatus:action.uiselectedOrderStatus
    }
  }),

  on(OrderUIActions.clearUISelectedOrderStatus,(state,action) => {
    return{
      ...state,
      uiselectedOrderStatus:initialState.uiselectedOrderStatus
    }
  }),


  on(OrderUIActions.setUISelectedOrderCreator,(state,action) => {
    return{
      ...state,
      uiselectedOrderCreator:action.uiselectedOrderCreator
    }
  }),

  on(OrderUIActions.clearUISelectedOrderCreator,(state,action) => {
    return{
      ...state,
      uiselectedOrderCreator:initialState.uiselectedOrderCreator
    }
  }),

  on(OrderUIActions.setUISelectedOrderTimeRange,(state,action) => {
    return{
      ...state,
      uiselectedOrderTimeRange:action.uiselectedOrderTimeRange
    }
  }),

  on(OrderUIActions.clearUISelectedOrderTimeRange,(state,action) => {
    return{
      ...state,
      uiselectedOrderTimeRange:initialState.uiselectedOrderTimeRange
    }
  }),

  on(OrderUIActions.setuiOrderDetailLoading,(state,action)=>{
    return{
      ...state,
      uiOrderDetailLoading:action.uiOrderDetailLoading,
    }
  }),

  on(OrderUIActions.clearuiOrderDetailLoading,(state)=>{
    return{
      ...state,
      uiOrderDetailLoading:initialState.uiOrderDetailLoading,
    }
  }),

  on(OrderUIActions.setUISearchPurchaserName,(state,action) => {
    return {
      ...state,
      uiSearchPurchaserName: action.uiSearchPurchaserName
    }
  }),

  on(OrderUIActions.clearUISearchPurchaserName,(state,action) => {
    return{
      ...state,
      uiSearchPurchaserName:initialState.uiSearchPurchaserName
    }
  }),

  on(OrderUIActions.setuiOrderListTableLoading,(state,action)=>{
    return{
      ...state,
      uiOrderListTableLoading:action.uiOrderListTableLoading,
    }
  }),

  on(OrderUIActions.clearuiOrderListTableLoading,(state)=>{
    return{
      ...state,
      uiOrderListTableLoading:initialState.uiOrderListTableLoading,
    }
  }),

  on(OrderUIActions.setUIPreviewOrderUploadLoading,(state,action) => {
    return{
      ...state,
      uiPreviewOrderUploadLoading:action.uiPreviewOrderUploadLoading
    }
  }),

  on(OrderUIActions.clearUIPreviewOrderUploadLoading,(state,action) => {
    return{
      ...state,
      uiPreviewOrderUploadLoading:initialState.uiPreviewOrderUploadLoading
    }
  }),

  on(OrderUIActions.setuiPreferenceSOCraeteLoading,(state,action)=>{
    return{
      ...state,
      uiPreferenceSOCraeteLoading:action.uiPreferenceSOCraeteLoading
    }
  }),

  on(OrderUIActions.clearuiPreferenceSOCraeteLoading,(state)=>{
    return{
      ...state,
      uiPreferenceSOCraeteLoading:initialState.uiPreferenceSOCraeteLoading
    }
  }),

  on(OrderUIActions.setUISelectedOrderSource,(state,action) => {
    return{
      ...state,
      uiselectedOrderSource:action.uiselectedOrderSource
    }
  }),

  on(OrderUIActions.clearUISelectedOrderSource,(state) => {
    return{
      ...state,
      uiselectedOrderSource:initialState.uiselectedOrderSource
    }
  }),

  on(OrderUIActions.setUISelectedOrderCustomerName,(state,action) => {
    return{
      ...state,
      uiselectedOrderCustomerName:action.uiselectedOrderCustomerName
    }
  }),

  on(OrderUIActions.clearUISelectedOrderCustomerName,(state) => {
    return{
      ...state,
      uiselectedOrderCustomerName:initialState.uiselectedOrderCustomerName
    }
  }),

  on(OrderUIActions.setUISelectedOrderProcessor,(state,action) => {
    return{
      ...state,
      uiselectedOrderProcessor:action.uiselectedOrderProcessor
    }
  }),

  on(OrderUIActions.clearUISelectedOrderProcessor,(state) => {
    return{
      ...state,
      uiselectedOrderProcessor:initialState.uiselectedOrderProcessor
    }
  }),

  on(OrderUIActions.setUISelectedOrderCustomerCode,(state,action) => {
    return{
      ...state,
      uiselectedOrderCustomerCode:action.uiselectedOrderCustomerCode
    }
  }),

  on(OrderUIActions.clearUISelectedOrderProcessor,(state) => {
    return{
      ...state,
      uiselectedOrderCustomerCode:initialState.uiselectedOrderCustomerCode
    }
  }),

  on(OrderUIActions.clearAllUiSelectedOrderFitler,(state) =>{
    return {
      ...state,
      uiselectedOrderStatus:initialState.uiselectedOrderStatus,
      uiselectedOrderCreator:initialState.uiselectedOrderCreator,
      uiselectedOrderTimeRange:initialState.uiselectedOrderTimeRange,
      uiselectedOrderSource:initialState.uiselectedOrderSource,
      uiselectedOrderCustomerName:initialState.uiselectedOrderCustomerName,
      uiselectedOrderCustomerCode:initialState.uiselectedOrderCustomerCode,
      uiselectedOrderProcessor:initialState.uiselectedOrderProcessor,
    }
  })

);


